<template>
  <div>
    <svg :width="size" :height="size" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <!-- Круговая анимация загрузки -->
      <circle cx="12" cy="12" r="10" stroke="#e0e0e0" stroke-width="2" fill="none"/>
      <circle cx="12" cy="12" r="10" stroke="#4285f4" stroke-width="2" fill="none" stroke-linecap="round">
        <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 12 12"
            to="360 12 12"
            dur="1.5s"
            repeatCount="indefinite"
        />
        <animate
            attributeName="stroke-dasharray"
            values="0, 62.8; 31.4, 31.4; 62.8, 0"
            dur="1.5s"
            repeatCount="indefinite"
        />
        <animate
            attributeName="stroke-dashoffset"
            values="0; 0; -62.8"
            dur="1.5s"
            repeatCount="indefinite"
        />
      </circle>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'LoaderIcon',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 64,
    }
  }
}
</script>

<style scoped>

</style>